import { render, staticRenderFns } from "./ksfxPage.vue?vue&type=template&id=95c06812&"
import script from "./ksfxPage.vue?vue&type=script&lang=js&"
export * from "./ksfxPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports